import { chapters, type ServiceInfoChapter } from '../chapters';
import { FeedbackPage } from './FeedbackPage';
import { IntroductionPage } from './IntroductionPage';
import { WhatsNewPage } from './WhatsNewPage';

type PagesProps = {
    page: ServiceInfoChapter;
};

export const Pages = ({ page = chapters.whatsNew }: PagesProps) => {
    switch (page) {
        case chapters.welcome:
            return <IntroductionPage />;
        case chapters.whatsNew:
            return <WhatsNewPage />;
        case chapters.feedback:
            return <FeedbackPage />;
        default:
            return <IntroductionPage />;
    }
};
